import type { AppType } from '@kiku/backend/app';
import { frontendConfig } from '@kiku/config/env/frontend';
import { hc } from 'hono/client';

export const api = hc<AppType>(frontendConfig.VITE_API_BASE_URL, {
  init: { credentials: 'include' }
});
